import Vue from 'vue'
import VueI18n from 'vue-i18n'
import mainI18n from '../../i18n'

Vue.use(VueI18n)

// Load broker-specific messages
function loadBrokerMessages() {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}

  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  })

  return messages
}

// Merge broker messages with main app messages
function mergeMessages() {
  const brokerMessages = loadBrokerMessages()
  const mainMessages = mainI18n.messages
  const mergedMessages = {}

  // Get all available locales from both sources
  const allLocales = new Set([
    ...Object.keys(brokerMessages),
    ...Object.keys(mainMessages)
  ])

  // Merge messages for each locale
  allLocales.forEach(locale => {
    mergedMessages[locale] = {
      ...(mainMessages[locale] || {}),
      ...(brokerMessages[locale] || {})
    }
  })

  return mergedMessages
}

// Create broker-specific i18n instance
const brokerI18n = new VueI18n({
  locale: mainI18n.locale,
  fallbackLocale: mainI18n.fallbackLocale,
  messages: mergeMessages(),
  silentTranslationWarn: true
})

// Sync locale changes with main i18n
export const setLocale = (locale) => {
  brokerI18n.locale = locale
  mainI18n.locale = locale
  localStorage.setItem('user-locale', locale)
  document.querySelector('html').setAttribute('lang', locale)
}

// Get current locale
export const getLocale = () => brokerI18n.locale

// Get available locales
export const getAvailableLocales = () => {
  return [
    { code: 'en', name: 'English', flag: 'US' },
    { code: 'es', name: 'Español', flag: 'ES' },
    { code: 'ja', name: '日本語', flag: 'JP' },
    { code: 'ko', name: '한국어', flag: 'KR' },
    { code: 'pt', name: 'Português', flag: 'PT' },
    { code: 'th', name: 'ไทย', flag: 'TH' },
    { code: 'vi', name: 'Tiếng Việt', flag: 'VN' },
    { code: 'zh', name: '简体中文', flag: 'CN' },
    { code: 'zh-Hant', name: '繁體中文', flag: 'TW' }
  ]
}

export default brokerI18n